import { render, staticRenderFns } from "./full-loading.vue?vue&type=template&id=40da31a0&"
import script from "./full-loading.vue?vue&type=script&lang=js&"
export * from "./full-loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports